export default "__VITE_ASSET__ClzYT8bb__"